import React, { useEffect, useState } from "react";
import { CheckBoxtParamsReadOnly } from "./JobReadOnly";
import { getLabelName } from "./Utils";
import Input from "../../FormComponents/Input";

const GetCheckBoxParamsData = ({
  keyName,
  params,
  isReadOnly,
  editJobData,
  setParams,
  preRequirements,
  setEditJobData
  // type
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const paramsSelector = (e, keyName) => {
    const newParams = { ...params };
    newParams[keyName] = e.target.checked;
    setParams(newParams);
    setEditJobData(null);
  };

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      if (editJobData) {
        setParams({ ...params, [keyName]: editJobData.params[keyName] });
      } else {
        setParams({ ...params, [keyName]: false });
      }
      setIsLoading(false);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);
  if (isLoading) return;
  return (
    <>
      <CheckBoxtParamsData
        keyName={keyName}
        label={getLabelName(keyName)}
        onChange={(e) => paramsSelector(e, keyName)} //e, key
        isReadOnly={isReadOnly}
        params={params}
      />
    </>
  );
};

const CheckBoxtParamsData = ({ keyName, label, onChange, isReadOnly, params }) => {
  if (isReadOnly) {
    return <CheckBoxtParamsReadOnly label={label} params={params} keyName={keyName} />;
  }
  return (
    <>
      <div className="builder_form">
        <Input label={`Select ${label}`} type="checkbox" id="checkbox" checked={params[keyName]} onChange={onChange} />
      </div>
    </>
  );
};

export default GetCheckBoxParamsData;
